import React, { Component } from 'react'
import './About.css'
import $ from "jquery"

class About extends Component {

  closeAbout(e) {
    e.preventDefault()
    $('#about').fadeOut()
  }

  componentDidMount() {
    var _self = this
    var url = 'https://api.culturecompass.org/about?_format=json'
    var settings = {
      "async": true,
      "crossDomain": true,
      "url": url,
      "method": "GET"
    }
     $.ajax(settings).done(function(response) {
       console.log(response[0]['body'])
       _self.setState({ 'data': response[0]['body'] })
     })
  }


  render() {
    return (
      <div>
        <div id="about">
         <a className="close" href="#close" onClick={(e) => this.closeAbout(e)}>x</a>
         { this.state && this.state.data &&
            <div className="content" dangerouslySetInnerHTML={{__html: this.state.data }} />
          }
          <div className="funders"></div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.js